window.onload = function(){
 var linkmsg=document.getElementById("linkmsg");
 linkmsg.style.visibility="visible";
 linkmsg.innerHTML="カラーを選択してください";
 document.getElementById("message").innerHTML = "";
    message.style.visibility="hidden";
 document.getElementById("opmsg").innerHTML = "<p> </p>";
    opmsg.style.visibility="hidden";
}
// cavaサイズ画像変更
function showimg1(){
document.area1.src = "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/cava_size.gif?v=1643522657";
document.getElementById("message").innerHTML = "<p> </p>";
message.style.visibility="hidden";
document.getElementById("opmsg").innerHTML = "<p> </p>";
opmsg.style.visibility="hidden";
}
function showimg2(){
document.area1.src = "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/cava_size_legnt.gif?v=1643522726";
document.getElementById("message").innerHTML = "<p>※本体の高さに6cmプラスとなります</p>";
message.style.visibility="visible";
document.getElementById("opmsg").innerHTML = "<p>※脚を除く本体の高さをご選択ください</p>";
opmsg.style.visibility="visible";
}
function showimg3(){
document.area1.src = "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/cava_size_legbr.gif?v=1643522727";
document.getElementById("message").innerHTML = "<p>※本体の高さに6cmプラスとなります</p>";
message.style.visibility="visible";
document.getElementById("opmsg").innerHTML = "<p>※脚を除く本体の高さをご選択ください</p>";
opmsg.style.visibility="visible";
}

// Cava サイズオーダー
function checkBtn(){
 var idCloth = document.getElementsByName( "cava_tab" ) ;
 var strCloth = "";
 var i=0;
 for ( strCloth="", i=idCloth.length; i--; ) {
  if ( idCloth[i].checked ) {
   strCloth = idCloth[i].id.slice(4);
   break ;
  }
 }
 var idColor = document.getElementsByName( "colortype" ) ;
 var strColor=""
 for (strColor="", i=idColor.length; i--; ) {
  if ( idColor[i].checked ) {
   strColor = idColor[i].id ;
   break ;
  }
 }
 var linkmsg=document.getElementById("linkmsg");
 var strErrmsg="";
 if(strCloth.slice(0,2)!=strColor.slice(0,2)){
  linkmsg.style.visibility="visible";
  strErrmsg="カラーを選択してください";
  document.getElementById("price").value=""
  document.frm_detail.checkbtn.disabled =true;
 }else if(strCloth.slice(0,2)=="mo"&&strColor.slice(0,2)=="mo"){
  if(strCloth.slice(0,3)!=strColor.slice(0,3)){
   linkmsg.style.visibility="visible";
   strErrmsg="カラーを選択してください";
   document.getElementById("price").value=""
   document.frm_detail.checkbtn.disabled =true;
     }else{
   linkmsg.style.visibility="hidden";
   linkmsg.innerHTML="";
   document.getElementById("price").value=""
   document.frm_detail.checkbtn.disabled =false;
     }
 }else{
  linkmsg.style.visibility="hidden";
  linkmsg.innerHTML="";
  document.getElementById("price").value=""
  document.frm_detail.checkbtn.disabled =false;
 }
 if(strErrmsg!=""){
 linkmsg.innerHTML=strErrmsg;
    }
}
function checkOption(){
 document.getElementById("price").value=""
 cart_price.innerHTML =""+" 円";
 cart_haba.innerHTML="";
 cart_height.innerHTML="";
 cart_cloth.innerHTML="";
 cart_color.innerHTML="";
 cart_option.innerHTML="";
 additional_fee.innerHTML="";
 linkmsg.style.visibility="hidden"; //190208追加 
}
const strLink1="<a href=\"https://arneinteior.myshopify.com/products/"
const strLink2="\" target=\"_top\">→こちらのページよりお買い求めください。</a>"

function setGoods(url,haba,depth,height,price,cloth){
this.url=url;this.haba=haba;this.depth=depth;this.height=height;this.price=price;this.cloth=cloth;}
function searchURL(strHaba,strDepth,strHeight,strCloth){
var strErr;
//var intDepth=document.getElementById("depth").value
var intHaba=document.getElementById("haba").value
//幅チェック
if (intHaba < 40){strErr="幅40cm未満";}
else if (intHaba > 190){
  strErr="幅191cm以上";}
if(strErr){document.getElementById("price").value="";
return strErr+"はオーダー不可です。";}
//幅サイズ成形
switch(strHaba.length){
 case 2:
  if(strHaba.slice(0,1)=="9" && strHaba.slice(-1)!="0"){
   strHaba ="100";
  }else if(strHaba.slice(-1) !="0"){
   strHaba=parseInt(strHaba.slice(0,1))+1+"0";
  }else{
   
  }
  break;
 case 3:
  if(strHaba.slice(-1)=="0"){
   
  }else{
  strHaba=strHaba.slice(0,1)+parseInt(parseInt(strHaba.slice(1,2))+1)+"0";
  }
  break;
}
//ベース価格
var basePrice = [35000,50000,45000,55000,65000];
var addPrice = [5000,5000,7000,7000];
var mulHaba;
var sellPrice;
var i=0
 mulHaba=(parseInt(strHaba)-40)/10;
 if(strCloth=="ns7" || strCloth=="sofia" || strCloth=="modern" || strCloth=="meisai"){
  sellPrice =  parseInt(basePrice[i])+(parseInt(addPrice[i])*parseInt(mulHaba));
 }else if(strCloth=="oct" || strCloth=="flower" || strCloth=="illust" || strCloth=="pattern" || strCloth=="resort"){
  sellPrice =  parseInt(basePrice[i+1])+(parseInt(addPrice[i+1])*parseInt(mulHaba));
 }else if(strCloth=="leather" || strCloth=="chappy" || strCloth=="magic" || strCloth=="denim" || strCloth=="moq" || strCloth=="holiday" || strCloth=="meta"){
  sellPrice =  parseInt(basePrice[i+2])+(parseInt(addPrice[i+2])*parseInt(mulHaba));
 }else if(strCloth=="michael"){
  sellPrice =  parseInt(basePrice[i+3])+(parseInt(addPrice[i+2])*parseInt(mulHaba));
 }else if(strCloth=="caleido"){
  sellPrice =  parseInt(basePrice[i+4])+(parseInt(addPrice[i+3])*parseInt(mulHaba));
 }else{
 alert("生地を選択してください");
 return false;
}
var existingprice=checkPrice(strHaba,strDepth,strHeight,strCloth,strOption);
 if(!existingprice == ""){
 existingprice=parseInt(existingprice);
  if(strOption!="noleg"){
   sellPrice = existingprice+3000;
   return sellPrice;
  }else if(strOption=="noleg"){
   sellPrice = existingprice;
   return sellPrice;
  }
 }else if(existingprice == ""){
  if(strOption!="noleg"){
   sellPrice = sellPrice+3000;
   return sellPrice;
  }else if(strOption=="noleg"){
   return sellPrice;
  }
 }
}
/*リストから商品URLを取得*/
function checkURL(strHaba,strDepth,strHeight,strCloth){
  for(var i in goods){
if(goods[i].haba==strHaba && goods[i].depth==strDepth && goods[i].height==strHeight && goods[i].cloth==strCloth){
return goods[i].url;}}
return false;
}
/*リストから価格を取得(201902追加)*/
function checkPrice(strHaba,strDepth,strHeight,strCloth){
  for(var i in goods){
if(goods[i].haba==strHaba && goods[i].depth==strDepth && goods[i].height==strHeight && goods[i].cloth==strCloth){
return goods[i].price;}}
return false;
}
// 数値チェック
function isNumber(numVal){
  var pattern =/^([1-9]\d*|0)$/;
  return pattern.test(numVal);
}
/*価格算出ボタン押下時*/
function jump(){
 document.getElementById("price").value =""+" 円";
 cart_price.innerHTML =""+" 円";
 cart_haba.innerHTML="";
 cart_height.innerHTML="";
 cart_cloth.innerHTML="";
 cart_color.innerHTML=""; 
 cart_option.innerHTML="";
 additional_fee.innerHTML="";
var linkmsg=document.getElementById("linkmsg");
linkmsg.innerHTML="";
linkmsg.style.visibility="hidden";
var ErrMsg=document.getElementById("linkmsg");
ErrMsg.innerHTML="";
document.getElementById("price").value=""
var strDepth="64"
var strHaba=document.getElementById("haba").value;
var strHeight=document.getElementById("height").value;
var idCloth = document.getElementsByName( "cava_tab" ) ;
var idColor = document.getElementsByName( "colortype" ) ;
var idOption = document.getElementsByName( "option" ) ;
var strCloth = "";
var strColor = "";
var i=0;
var a=0;
var c=0;
for ( strCloth="", i=idCloth.length; i--; ) {
 if ( idCloth[i].checked ) {
  strCloth = idCloth[i].id.slice(4);
  var valueCloth = idCloth[i].value ;
  break ;
 }
}
for ( strColor="", a=idColor.length; a--; ) {
 if ( idColor[a].checked ) {
  strColor = idColor[a].id ;
  var valueColor = idColor[a].value ;
  break ;
 }
}
for ( strOption="", c=idOption.length; c--; ) {
 if ( idOption[c].checked ) {
  strOption = idOption[c].id ;
  var total;
  if( strOption!="noleg" ){total = 3000;}else{total = 0;}
  var valueOption = idOption[c].value ;
  break ;
 }
}
if (isNumber(strHaba)==false){
alert("幅は『1以上の整数(小数点不可/半角文字）』をご入力ください。");
return false;
}
document.getElementById("choice1").value=strHaba+"cm"
document.getElementById("choice2").value=strHeight+"cm"
document.getElementById("choice3").value=valueCloth+"生地"
document.getElementById("choice4").value=valueColor
document.getElementById("choice5").value=valueOption
document.getElementById("choice7").value=total


//商品ページの有無チェック（別注色シルバーグレー追加）
var comcode=checkURL(strHaba,strDepth,strHeight,strCloth,strOption);
if (!comcode=="" && strColor=="moq_sgy" && strOption=="noleg"){
var target=document.getElementById("linkmsg");
linkmsg.style.visibility="visible";
target.innerHTML="モケット生地シルバーグレーは別注色のため金額が異なります。";
}

else if (!comcode=="" && strOption=="noleg"){
var target=document.getElementById("linkmsg");
linkmsg.style.visibility="visible";
target.innerHTML="ご希望サイズは既製品がございます。<br>"+strLink1+comcode+"/"+strLink2;
return false;
}
var url=searchURL(strHaba,strDepth,strHeight,strCloth,strOption);
if(!url){
alert("幅を入力してください");
return false;
}
var intUnit
if (isNaN(url)==false){
 intUnit=parseInt(url)/1000;
 document.getElementById("price").value =parseInt(url).toLocaleString()+" 円";
 cart_price.innerHTML =parseInt(url).toLocaleString()+" 円";
 cart_haba.innerHTML=strHaba;
 cart_height.innerHTML=strHeight;
 cart_cloth.innerHTML=valueCloth;
 cart_color.innerHTML=valueColor;
 cart_option.innerHTML=valueOption;
 additional_fee.innerHTML=total;
}
else if(isNaN(url)==true) {
linkmsg.style.visibility="visible";
 ErrMsg.innerHTML=url;
 intUnit=""
}
document.getElementById("units").value=intUnit;
document.getElementById("choice6").value="見積もり金額："+url;
return false;
}
function checkText() {
 var choice1=document.frm.choice1.value;
 var choice2=document.frm.choice2.value;
 var choice3=document.frm.choice3.value;  
 var choice4=document.frm.choice4.value;  
 var choice5=document.frm.choice5.value; 
    var text = document.frm.inventory_id.value;
    var price = document.frm_detail.price.value;
    if(choice1=="" || choice2=="") {
        alert("ご希望のサイズを正しく入力後、価格算出ボタンを押してください。");
        return false;
        }           

    if(price=="") {
        alert("価格が算出されていません。既製品がある場合、「この条件で金額算出」ボタン下の該当商品ページよりお買い求めください。");
        return false;
        }       
     return true;
}
goods = new Object();
goods[0] =new setGoods("0000a41929","40","64","78","35000","ns7");
goods[1] =new setGoods("0000a41935","40","64","78","35000","sofia");
goods[2] =new setGoods("0000a41947","40","64","78","35000","modern");
goods[3] =new setGoods("0000a41950","40","64","78","50000","oct");
goods[4] =new setGoods("0000a41954","40","64","78","45000","moq");
goods[5] =new setGoods("0000a41964","40","64","78","55000","michael");
goods[6] =new setGoods("0000a41974","40","64","78","45000","leather");
goods[7] =new setGoods("0000a41979","40","64","78","45000","chappy");
goods[8] =new setGoods("0000a41980","40","64","78","45000","denim");
goods[9] =new setGoods("0000a41985","40","64","78","35000","meisai");
goods[10] =new setGoods("0000a41988","40","64","78","50000","flower");
goods[11] =new setGoods("0000a41990","40","64","78","45000","magic");
goods[12] =new setGoods("0000a41997","40","64","78","50000","illust");
goods[13] =new setGoods("0000a42002","40","64","78","50000","pattern");
goods[14] =new setGoods("0000a42008","40","64","78","65000","caleido");
goods[15] =new setGoods("0000a42021","90","64","78","60000","ns7");
goods[16] =new setGoods("0000a42027","90","64","78","60000","sofia");
goods[17] =new setGoods("0000a42039","90","64","78","60000","modern");
goods[18] =new setGoods("0000a42042","90","64","78","75000","oct");
goods[19] =new setGoods("0000a42046","90","64","78","80000","moq");
goods[20] =new setGoods("0000a42056","90","64","78","90000","michael");
goods[21] =new setGoods("0000a42066","90","64","78","80000","leather");
goods[22] =new setGoods("0000a42071","90","64","78","80000","chappy");
goods[23] =new setGoods("0000a42072","90","64","78","80000","denim");
goods[24] =new setGoods("0000a42077","90","64","78","60000","meisai");
goods[25] =new setGoods("0000a42080","90","64","78","75000","flower");
goods[26] =new setGoods("0000a42082","90","64","78","80000","magic");
goods[27] =new setGoods("0000a42089","90","64","78","75000","illust");
goods[28] =new setGoods("0000a42094","90","64","78","75000","pattern");
goods[29] =new setGoods("0000a42100","90","64","78","100000","caleido");
goods[30] =new setGoods("0000a42113","120","64","78","75000","ns7");
goods[31] =new setGoods("0000a42119","120","64","78","75000","sofia");
goods[32] =new setGoods("0000a42131","120","64","78","75000","modern");
goods[33] =new setGoods("0000a42134","120","64","78","90000","oct");
goods[34] =new setGoods("0000a42138","120","64","78","101000","moq");
goods[35] =new setGoods("0000a42148","120","64","78","111000","michael");
goods[36] =new setGoods("0000a42158","120","64","78","101000","leather");
goods[37] =new setGoods("0000a42163","120","64","78","101000","chappy");
goods[38] =new setGoods("0000a42164","120","64","78","101000","denim");
goods[39] =new setGoods("0000a42169","120","64","78","75000","meisai");
goods[40] =new setGoods("0000a42172","120","64","78","90000","flower");
goods[41] =new setGoods("0000a42174","120","64","78","101000","magic");
goods[42] =new setGoods("0000a42181","120","64","78","90000","illust");
goods[43] =new setGoods("0000a42186","120","64","78","90000","pattern");
goods[44] =new setGoods("0000a42192","120","64","78","113000","caleido");
goods[45] =new setGoods("0000a42205","160","64","78","95000","ns7");
goods[46] =new setGoods("0000a42211","160","64","78","95000","sofia");
goods[47] =new setGoods("0000a42223","160","64","78","95000","modern");
goods[48] =new setGoods("0000a42226","160","64","78","110000","oct");
goods[49] =new setGoods("0000a42230","160","64","78","129000","moq");
goods[50] =new setGoods("0000a42240","160","64","78","139000","michael");
goods[51] =new setGoods("0000a42250","160","64","78","129000","leather");
goods[52] =new setGoods("0000a42255","160","64","78","129000","chappy");
goods[53] =new setGoods("0000a42256","160","64","78","129000","denim");
goods[54] =new setGoods("0000a42261","160","64","78","95000","meisai");
goods[55] =new setGoods("0000a42264","160","64","78","110000","flower");
goods[56] =new setGoods("0000a42266","160","64","78","129000","magic");
goods[57] =new setGoods("0000a42273","160","64","78","110000","illust");
goods[58] =new setGoods("0000a42278","160","64","78","110000","pattern");
goods[59] =new setGoods("0000a42284","160","64","78","141000","caleido");
goods[60] =new setGoods("0000a42297","190","64","78","110000","ns7");
goods[61] =new setGoods("0000a42303","190","64","78","110000","sofia");
goods[62] =new setGoods("0000a42315","190","64","78","110000","modern");
goods[63] =new setGoods("0000a42318","190","64","78","125000","oct");
goods[64] =new setGoods("0000a42322","190","64","78","150000","moq");
goods[65] =new setGoods("0000a42332","190","64","78","160000","michael");
goods[66] =new setGoods("0000a42342","190","64","78","150000","leather");
goods[67] =new setGoods("0000a42347","190","64","78","150000","chappy");
goods[68] =new setGoods("0000a42348","190","64","78","150000","denim");
goods[69] =new setGoods("0000a42353","190","64","78","110000","meisai");
goods[70] =new setGoods("0000a42356","190","64","78","125000","flower");
goods[71] =new setGoods("0000a42358","190","64","78","150000","magic");
goods[72] =new setGoods("0000a42365","190","64","78","125000","illust");
goods[73] =new setGoods("0000a42370","190","64","78","125000","pattern");
goods[74] =new setGoods("0000a42376","190","64","78","162000","caleido");
goods[75] =new setGoods("0000a42389","40","64","73","35000","ns7");
goods[76] =new setGoods("0000a42395","40","64","73","35000","sofia");
goods[77] =new setGoods("0000a42407","40","64","73","35000","modern");
goods[78] =new setGoods("0000a42410","40","64","73","50000","oct");
goods[79] =new setGoods("0000a42414","40","64","73","45000","moq");
goods[80] =new setGoods("0000a42424","40","64","73","55000","michael");
goods[81] =new setGoods("0000a42434","40","64","73","45000","leather");
goods[82] =new setGoods("0000a42439","40","64","73","45000","chappy");
goods[83] =new setGoods("0000a42440","40","64","73","45000","denim");
goods[84] =new setGoods("0000a42445","40","64","73","35000","meisai");
goods[85] =new setGoods("0000a42448","40","64","73","50000","flower");
goods[86] =new setGoods("0000a42450","40","64","73","45000","magic");
goods[87] =new setGoods("0000a42457","40","64","73","50000","illust");
goods[88] =new setGoods("0000a42462","40","64","73","50000","pattern");
goods[89] =new setGoods("0000a42468","40","64","73","65000","caleido");
goods[90] =new setGoods("0000a42481","90","64","73","60000","ns7");
goods[91] =new setGoods("0000a42487","90","64","73","60000","sofia");
goods[92] =new setGoods("0000a42499","90","64","73","60000","modern");
goods[93] =new setGoods("0000a42502","90","64","73","75000","oct");
goods[94] =new setGoods("0000a42506","90","64","73","80000","moq");
goods[95] =new setGoods("0000a42516","90","64","73","90000","michael");
goods[96] =new setGoods("0000a42526","90","64","73","80000","leather");
goods[97] =new setGoods("0000a42531","90","64","73","80000","chappy");
goods[98] =new setGoods("0000a42532","90","64","73","80000","denim");
goods[99] =new setGoods("0000a42537","90","64","73","60000","meisai");
goods[100] =new setGoods("0000a42540","90","64","73","75000","flower");
goods[101] =new setGoods("0000a42542","90","64","73","80000","magic");
goods[102] =new setGoods("0000a42549","90","64","73","75000","illust");
goods[103] =new setGoods("0000a42554","90","64","73","75000","pattern");
goods[104] =new setGoods("0000a42560","90","64","73","100000","caleido");
goods[105] =new setGoods("0000a42573","120","64","73","75000","ns7");
goods[106] =new setGoods("0000a42579","120","64","73","75000","sofia");
goods[107] =new setGoods("0000a42591","120","64","73","75000","modern");
goods[108] =new setGoods("0000a42594","120","64","73","90000","oct");
goods[109] =new setGoods("0000a42598","120","64","73","101000","moq");
goods[110] =new setGoods("0000a42608","120","64","73","111000","michael");
goods[111] =new setGoods("0000a42618","120","64","73","101000","leather");
goods[112] =new setGoods("0000a42623","120","64","73","101000","chappy");
goods[113] =new setGoods("0000a42624","120","64","73","101000","denim");
goods[114] =new setGoods("0000a42629","120","64","73","75000","meisai");
goods[115] =new setGoods("0000a42632","120","64","73","90000","flower");
goods[116] =new setGoods("0000a42634","120","64","73","101000","magic");
goods[117] =new setGoods("0000a42641","120","64","73","90000","illust");
goods[118] =new setGoods("0000a42646","120","64","73","90000","pattern");
goods[119] =new setGoods("0000a42652","120","64","73","113000","caleido");
goods[120] =new setGoods("0000a42665","160","64","73","95000","ns7");
goods[121] =new setGoods("0000a42671","160","64","73","95000","sofia");
goods[122] =new setGoods("0000a42683","160","64","73","95000","modern");
goods[123] =new setGoods("0000a42686","160","64","73","110000","oct");
goods[124] =new setGoods("0000a42690","160","64","73","129000","moq");
goods[125] =new setGoods("0000a42700","160","64","73","139000","michael");
goods[126] =new setGoods("0000a42710","160","64","73","129000","leather");
goods[127] =new setGoods("0000a42715","160","64","73","129000","chappy");
goods[128] =new setGoods("0000a42716","160","64","73","129000","denim");
goods[129] =new setGoods("0000a42721","160","64","73","95000","meisai");
goods[130] =new setGoods("0000a42724","160","64","73","110000","flower");
goods[131] =new setGoods("0000a42726","160","64","73","129000","magic");
goods[132] =new setGoods("0000a42733","160","64","73","110000","illust");
goods[133] =new setGoods("0000a42738","160","64","73","110000","pattern");
goods[134] =new setGoods("0000a42744","160","64","73","141000","caleido");
goods[135] =new setGoods("0000a42757","190","64","73","110000","ns7");
goods[136] =new setGoods("0000a42763","190","64","73","110000","sofia");
goods[137] =new setGoods("0000a42775","190","64","73","110000","modern");
goods[138] =new setGoods("0000a42778","190","64","73","125000","oct");
goods[139] =new setGoods("0000a42782","190","64","73","150000","moq");
goods[140] =new setGoods("0000a42792","190","64","73","160000","michael");
goods[141] =new setGoods("0000a42802","190","64","73","150000","leather");
goods[142] =new setGoods("0000a42807","190","64","73","150000","chappy");
goods[143] =new setGoods("0000a42808","190","64","73","150000","denim");
goods[144] =new setGoods("0000a42813","190","64","73","110000","meisai");
goods[145] =new setGoods("0000a42816","190","64","73","125000","flower");
goods[146] =new setGoods("0000a42818","190","64","73","150000","magic");
goods[147] =new setGoods("0000a42825","190","64","73","125000","illust");
goods[148] =new setGoods("0000a42830","190","64","73","125000","pattern");
goods[149] =new setGoods("0000a42836","190","64","73","162000","caleido");
